import type { ReactElement, ReactNode } from 'react'
import { Children, isValidElement } from 'react'

export const withSpacers = (children: ReactNode, spacer: (key: string) => ReactElement) =>
  Children.toArray(children)
    .filter(isValidElement)
    .flatMap((child, index, items) =>
      index < items.length - 1 ? [child, spacer(`spacer-${index.toString()}`)] : [child]
    )
